import { createSlice } from "@reduxjs/toolkit";

// Detalle 2 de la puntuacion: los grupos de la escala (puntuaciongrupo).
//
// Cada grupo tiene su subdetalle (puntuacionGrupoDetalle): los
// puntuaciondetalle que lo forman. El subdetalle se edita dentro de la fila
// del grupo y se guarda con el.
const initialState = {
    defaultEntity: [{
        id: 0,
        numero: 0,
        idPuntuacion: 0,
        descripcion: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,

        puntuacionGrupoDetalle: [],
    }],
    entity: [{
        id: 0,
        numero: 0,
        idPuntuacion: 0,
        descripcion: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,

        puntuacionGrupoDetalle: [],
    }],
    // Detalles de la puntuacion, para elegir el subdetalle del grupo.
    listPuntuacionDetalle: [],
    validationActive: {
        AtLeastOneRow: false,
    },
    validationMessage: [],
}

export const puntuacionGrupoSlice = createSlice({
    name: "puntuacionGrupo",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        setData: (state, action) => {
            var { numero, name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            const index = state.entity.findIndex(item => item.numero === numero);
            state.entity[index][name] = value;

            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
        add: (state, action) => {
            var idPuntuacion = action.payload;

            var maxNumero = state.entity.length === 0 ? 0 : Math.max.apply(null, state.entity.map((item) => { return item.numero; }))

            state.entity.push({
                ...state.defaultEntity[0],
                numero: maxNumero + 1,
                idPuntuacion: idPuntuacion,
                puntuacionGrupoDetalle: [],
            });
        },
        remove: (state, action) => {
            state.entity = state.entity.filter(item => item.numero !== action.payload)
        },
        // Agrega un puntuaciondetalle al subdetalle de un grupo. No se
        // permite repetir el mismo detalle dentro del mismo grupo.
        addSubDetalle: (state, action) => {
            const { numero, idPuntuacionDetalle } = action.payload;
            const index = state.entity.findIndex(item => item.numero === numero);

            if (index < 0) return;

            const grupo = state.entity[index];

            if (grupo.puntuacionGrupoDetalle == null) {
                grupo.puntuacionGrupoDetalle = [];
            }

            if (grupo.puntuacionGrupoDetalle.some((x) => x.idPuntuacionDetalle === idPuntuacionDetalle)) return;

            grupo.puntuacionGrupoDetalle.push({
                idPuntuacionGrupo: grupo.id,
                numero: grupo.puntuacionGrupoDetalle.length + 1,
                idPuntuacionDetalle: idPuntuacionDetalle,
                valor: 0,
                texto: "",
                descripcion: "",
            });
        },
        removeSubDetalle: (state, action) => {
            const { numero, indice } = action.payload;
            const index = state.entity.findIndex(item => item.numero === numero);

            if (index < 0) return;

            state.entity[index].puntuacionGrupoDetalle =
                state.entity[index].puntuacionGrupoDetalle.filter((x, i) => i !== indice);

            // Se renumera para que no queden huecos.
            state.entity[index].puntuacionGrupoDetalle.forEach((x, i) => { x.numero = i + 1; });
        },
        setListPuntuacionDetalle: (state, action) => {
            state.listPuntuacionDetalle = action.payload;
        },
        setValidations: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state, action) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
    },
});

export const { setEntity, setData, add, remove
    , addSubDetalle, removeSubDetalle
    , setListPuntuacionDetalle
    , setValidations, activeValidations } = puntuacionGrupoSlice.actions;
export default puntuacionGrupoSlice.reducer;